import moment from "../../moment";

export const reorderMyLimitedExpressTickets = (limitedExpressTickets) => {
  if (limitedExpressTickets.value == null) {
    return null;
  }

  let length = limitedExpressTickets.value.length;
  if (length < 2) {
    return limitedExpressTickets.value;
  }

  const now = moment(new Date());
  const defaultOrder = [...limitedExpressTickets.value];

  for (let i = 0; i < length; i++) {
    const ticket = defaultOrder[i];
    const ticketDateTime = moment(
      ticket.boarding_date + " " + ticket.departure_at,
      "YYYY-MM-DD HHmm"
    );
    const ticketDateTimeOver = moment(ticketDateTime).add(90, "m");

    if (now.isAfter(ticketDateTimeOver)) {
      const moveTicket = defaultOrder.shift();
      defaultOrder.push(moveTicket);
      i--;
      //reduce loop item
      length--;
    } else {
      //break the loop, because the data was order already
      break;
    }
  }
  return defaultOrder;
};
